import React, { useState } from 'react';
import Logo from "../assets/img/logo.png";
import { MdDashboard } from "react-icons/md";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaUser } from "react-icons/fa6";
import { MdLogout } from "react-icons/md";
import ResizeHook from '../Components/Hooks/ResizeHook';
import { deleteToken } from '../actions/commonFunction';
import { useDispatch } from 'react-redux';
import config from '../lib/config';
import { Log_Out } from '../actions/redux/action';
import { toast } from 'react-toastify';

import { RiNftFill } from "react-icons/ri";
import { MdCategory } from "react-icons/md";
import { FaQuestionCircle } from "react-icons/fa";
import { MdAnnouncement } from "react-icons/md";
import { BiBookContent } from "react-icons/bi";
import { MdContentPasteSearch } from "react-icons/md";
import { RiProfileLine } from "react-icons/ri";
import { MdReport } from "react-icons/md";
import { MdSupport } from "react-icons/md";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { MdOutlineCurrencyExchange } from "react-icons/md";
import { RiShieldUserFill } from "react-icons/ri";
import { BiSolidPurchaseTag } from "react-icons/bi";
import { FaTicket } from "react-icons/fa6";




const Sidebar = () => {


  const dispatch = useDispatch();


  const navigate = useNavigate();
  const location = useLocation();
  const widthResize = ResizeHook();

  const [sidebarlinks] = useState([
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: <MdDashboard />,
    },
    {
      path: "/TokenList",
      name: "NFT",
      icon: <RiNftFill />,
    },
    {
      path: "/UserList",
      name: "User",
      icon: <FaUser />,
    },
    {
      path: "/subscriberlist",
      name: "Subscriber List",
      icon: <BiSolidPurchaseTag />,
    },
    // {
    //   path: "/subscriberadd",
    //   name: "Subscriber Add",
    //   icon: <MdDashboard />,
    // },
    {
      path: "/categorylist",
      name: "Category",
      icon: <MdCategory />,
    },
    // {
    //   path: "/faqadd",
    //   name: "Faq add",
    //   icon: <MdDashboard />,
    // },
    {
      path: "/faqList",
      name: "Faq List",
      icon: <FaQuestionCircle />,
    },
    // {
    //   path: "/announcementadd",
    //   name: "Announcement Add",
    //   icon: <MdDashboard />,
    // },
    {
      path: "/announcementlist",
      name: "Announcement List",
      icon: <MdAnnouncement />,
    },
    {
      path: "/cmslist",
      name: "CMS Management",
      icon: <BiBookContent />,
    },
    {
      path: "/Cms",
      name: "Resource & Footer",
      icon: <MdContentPasteSearch />,
    },
    {
      path: "/newpromotionlist",
      name: "Promotion Management",
      icon: <RiProfileLine />,
    },
    // {
    //   path: "/AddCategory",
    //   name: "AddCategory",
    //   icon: <MdDashboard />,
    // },
    {
      path: "/reportlist",
      name: "Report Management",
      icon: <MdReport />,
    },
    {
      path: "/supportTicket",
      name: "Support Ticket",
      icon: <FaTicket />,
    },
    {
      path: "/editserviceFee",
      name: "Service Fee Management",
      icon: <MdOutlineMiscellaneousServices />,
    },
    {
      path: "/currency",
      name: "Currency Management",
      icon: <MdOutlineCurrencyExchange />,
    },
    {
      path: "/user",
      name: "Admin profile",
      icon: <FaUser />,
    },

  ]);

  const logoutuser = () => {
    let confirm = window.confirm("Do you want to sign out?")
    if (confirm) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem(config.adminWalletAddressKey);
      deleteToken(config.adminCookieName);
      dispatch({
        type: Log_Out,
      });
      navigate("/");
    }
    else {
      toast.error("Cancelled Logout");
    }
  }


  return (
    <div className="sidebar">
      <div className="sidebar_head">
        {
          widthResize > 991 ?
            <Link to="/dashboard">
              <img src={Logo} alt="Edaface" className="img-fluid logo" />
            </Link> :
            <p className="mobilesidebar_head">Welcome Admin</p>
        }
      </div>
      <div className="sidebar_body">
        <ul className="sidebar_ul">
          {
            sidebarlinks.map((sbl) => (
              <li className="sidebar_li" key={sbl.name}>
                <Link to={sbl.path} className={`sidebar_link ${location.pathname === sbl.path && "active"}`}>
                  {sbl.icon} {sbl.name}
                </Link>
              </li>
            ))
          }

          <li className="sidebar_li" key={"logout"}>
            <Link className={`sidebar_link`} type='button' onClick={logoutuser} >
              <MdLogout /> Logout
            </Link>
          </li>

        </ul>
      </div>
    </div>
  )
}

export default Sidebar;